/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-12 13:33:57
 * @LastEditTime : 2023-09-19 09:55:32
 * @LastEditors  : yangxr
 * @Description  : 退货任务API
 * @FilePath     : \icps_change\src\api\supplier\returnGoodsTask.js
 */
export const queryPage = '/icps/system/sign/dataCollection/returnGood/querySupperPage'